import { BarChart3, Building2, FileBarChart, Settings, Users, Wrench } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { VaniaQuickActionCard } from '@vanialabs/ui-engine';

const ACTIONS = [
  { label: 'کاربران', description: 'مدیریت کاربران', path: '/users', icon: Users },
  { label: 'تننت‌ها', description: 'مدیریت تننت‌ها', path: '/tenants', icon: Building2 },
  { label: 'سرویس‌ها', description: 'مدیریت سرویس‌ها', path: '/services', icon: Wrench },
  { label: 'سفارش‌ها', description: 'مدیریت سفارش‌ها', path: '/orders', icon: FileBarChart },
  { label: 'گزارش‌ها', description: 'تحلیل و گزارش‌ها', path: '/analytics', icon: BarChart3 },
  { label: 'تنظیمات', description: 'تنظیمات سیستم', path: '/settings', icon: Settings },
] as const;

export function ControlPlaneQuickActions() {
  const navigate = useNavigate();

  return <div className="vania-control-plane-actions">
    {ACTIONS.map(({ label, description, path, icon: Icon }) => <VaniaQuickActionCard key={path} className="vania-control-plane-action-card" label={label} description={description} icon={<Icon size={17} />} onClick={() => navigate(path)} />)}
  </div>;
}
